var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPetikSatu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.036 15.924C.542 10.947 4.664 1.431 17.714 0v5.758c-2.922.9-8.654 4.174-8.745 10.166h9.214v18.168H.015v-17.74H0l.015-.206v-.223h.02z",
    fill: "#232323"
  })));
}
export default SvgPetikSatu;